import React from 'react';
import ArrowButton from './ArrowButton';
import { ArrowsWrapper } from './ArrowButtons.styles';

export interface ArrowButtonsProps {
  goToNext: () => void;
  goToPrev: () => void;
}

const ArrowButtons: React.FC<ArrowButtonsProps> = ({ goToNext, goToPrev }) => {
  return (
    <ArrowsWrapper>
      <ArrowButton ariaLabel="Previous offer" onChange={goToPrev} buttonType="prev">
        Prev
      </ArrowButton>
      <ArrowButton ariaLabel="Next offer" onChange={goToNext} buttonType="next">
        Next
      </ArrowButton>
    </ArrowsWrapper>
  );
};

export default ArrowButtons;
